import React from 'react';
import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import linkify from 'linkify-it';

const MessageContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isLocalParticipant',
})<{ isLocalParticipant: boolean }>(({ isLocalParticipant }) => ({
  borderRadius: '16px',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.5em 0.8em 0.6em',
  margin: '0.3em 0 0',
  wordBreak: 'break-word',
  backgroundColor: isLocalParticipant ? '#CCE4FF' : '#E1E3EA',
  hyphens: 'auto',
  whiteSpace: 'pre-wrap',
}));

interface TextMessageProps {
  body: string;
  isLocalParticipant: boolean;
}

function addLinks(text: string) {
  const matches = new linkify().match(text);
  if (!matches) return text;

  const results = [];
  let lastIndex = 0;

  matches.forEach((match, i) => {
    results.push(text.slice(lastIndex, match.index));
    results.push(
      <Link target="_blank" rel="noreferrer" href={match.url} key={i}>
        {match.text}
      </Link>
    );
    lastIndex = match.lastIndex;
  });

  results.push(text.slice(lastIndex, text.length));

  return results;
}

export default function TextMessage({ body, isLocalParticipant }: TextMessageProps) {
  return (
    <div>
      <MessageContainer isLocalParticipant={isLocalParticipant}>
        <div>{addLinks(body)}</div>
      </MessageContainer>
    </div>
  );
}
